import React from "react";
import VoucherSearch from "@components/VoucherManager/VoucherSearch";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const GiftingPage = () => {


    return (
        <VersionedLayout>
            <VoucherSearch type="giftingVoucher" displayMode="gifting" />
        </VersionedLayout>
    );
};

export default GiftingPage;
